/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'
import {
	PanelBody, ToggleControl, RangeControl, BaseControl 
} from '@wordpress/components'
import {
	RichText
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import {
	URLInputControl, ColumnControl, ImageUploadPlaceholder
} from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.category-block.edit.inspector.style.before', 'czgb/category-block', ( output, props ) => {
	const { 
		attributes, 
		setAttributes,  
	} = props

	const {
		enablePosition,
		limit,
		smColumns,
		disableTitle
	} = props.attributes

	return (
		<Fragment>
			<PanelBody title={ __( 'General', i18n ) }>
				<ToggleControl
					label={ __( 'Enable Position', i18n ) }
					checked={ enablePosition }
					onChange={ enablePosition => setAttributes( { enablePosition } ) }
				/>
				<RangeControl
					label={ __( 'Number of Blocks', i18n ) }
					value={ limit !== undefined ? limit : 3 }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.category-block.limit.edit.inspector.max.limit', 6 ) }
				/>
				<ColumnControl
					smColumns={ smColumns }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
					smMin={ 1 }
					smMax={ 3 }
				/>
			</PanelBody>
			<PanelBody title={ __( 'General', i18n ) }>
				<ToggleControl
					label={ __( 'Disable Category Text', i18n ) }
					checked={ disableTitle }
					onChange={ disableTitle => setAttributes( { disableTitle } ) }
				/>
				{ range( 1, limit + 1 ).map( i => {
					const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

					return (
						<Fragment key={ i }>
							<BaseControl label={ __( `Link #${ i } Settings`, i18n ) } id={ "url" } >
								<URLInputControl
									value={ link }
									onChange={ link => setAttributes( { [ `link${ i }` ]: link } ) }
								/>
							</BaseControl>
						</Fragment>
					)
				} ) }
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className
	} = props 

	const {
		disableTitle,
		limit,
		smColumns,
		enablePosition
	} = attributes

	const mainClasses = classnames( [
		className,
		'czgb-category-block',
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, ( limit ) + 1 ).map( i => {

		const Title = attributes[ `title${ i }` ]
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'
		const titleColor = attributes[ `titlecolor${ i }` ]
		const customTitlecolor = attributes[ `customTitlecolor${ i }` ]
		const mediaURL = attributes[ `mediaURL${ i }` ]

		const SmallScreen = 12 / smColumns

		let defaultcategoryTitle = ''

		if ( i % 3 === 1 ) {
			defaultcategoryTitle = 'Men'
		}
		if ( i % 3 === 2 ) {
			defaultcategoryTitle = 'Women'
		}
		if ( i % 3 === 0 ) {
			defaultcategoryTitle = 'Kids'
		}

		const imageComp = (
			<ImageUploadPlaceholder
				imageURL={ mediaURL }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL } className= { `d-block rounded mb-3` } alt={ __( 'category ' ) } /> }
			/>
		)

		const titleComp = ( disableTitle === false ) && (
			<RichText
				tagName="h3"
				className={ `font-size-base pt-1 mb-0 ${ titleColor ? titleColor : customTitlecolor ? '' : 'text-dark' }` }
				value={ Title || defaultcategoryTitle }
				style={ { color: customTitlecolor } }
				onChange={ Title => setAttributes( { [ `title${ i }` ]: Title } ) }
				placeholder={ __( 'Title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const output = (
			<div className={ `col-sm-${ SmallScreen } px-2 mb-grid-gutter` }>
				<a className={ `d-block text-center text-decoration-none mr-1` } href={ link }>
					{ imageComp }
					{ titleComp }
				</a>
			</div>
		)
			
			return output
	}   )

	return (
		<div className={ mainClasses }>
			<section className={ `container position-relative pt-3 pt-lg-0 pb-5 cat-block ${ enablePosition === true ? 'mt-lg-n10' : '' }` } >
				<div className="row">
					<div className="col-xl-8 col-lg-9">
						<div className="border-0 box-shadow-lg card-size">
							<div className="card-body px-3 pt-grid-gutter pb-0">
								<div className="row no-gutters pl-1">
									{ content }
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
